import { combineReducers } from 'redux';
import { UserReducer, UserDataState } from 'app/pages/Users/ducks';
import result from '../redux/_reducer/results';
import { ResultState } from '../redux/_reducer/types';
import LocationReducer from '../redux/location/location.reducer';
import { LocationTypes } from '../redux/location/location.types';
import CountryInfoReducer from '../redux/countryInfo/countryInfo.reducer';
import SearchReducer, { SearchReducerTypes } from '../redux/search/search.reducer';

export interface StoreState {
  user: UserDataState;
  result: ResultState;
  locationsState: LocationTypes;
  search: SearchReducerTypes;
}

const rootReducer = combineReducers({
  user: UserReducer,
  result: result,
  locationsState: LocationReducer,
  countryInfo: CountryInfoReducer,
  search: SearchReducer
});

export default rootReducer;
